<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19NqI8m/images/cover.jpg?1703000716456" alt="This image is the cover for the book Undertown, Volume 1, Undertown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Undertown, Volume 1, Undertown
      </h1>
      <p class="bookDescription body article font2">
        <b>“This fantasy manga presents the right mix of familiar tropes along with new ideas that should capture the imaginations of more than a few readers.</b>” —<b><i>Publishers Weekly</i></b><br/>  <br/> Meet Sama, a young boy who is so sad that tears have literally stained his cheeks. Sama's father has had a heart attack, and doctors give him a month to live. With his teddy bear in tow, Sama crawls under his bed and finds a magical portal to a strange realm called Undertown. What is this dark new world? To find out, Sama begins a journey through the depths of Undertown, where he searches for The Sugar Stone, a magical object that might be able to save his dad!  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Pascoe, Jake Myler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tokyopop Verlag
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ebb765b8